import React, { memo } from 'react';
import Link from 'next/link';
import { Container } from 'react-bootstrap';

const cityData = [
  { label: 'Call Girl in Bangalore', city: 'bangalore' },
  { label: 'Call Girl in Jaipur', city: 'jaipur' },
  { label: 'Call Girl in Pune', city: 'pune' },
  { label: 'Call Girl in Mumbai', city: 'mumbai' },
  { label: 'Call Girl in Chennai', city: 'Chennai' },
  { label: 'Call Girl in Hyderabad', city: 'Hyderabad' },
  { label: 'Call Girl in Udaipur', city: 'udaipur' },
];

function TopCity(props: any) {
  const { queryData } = props;
  return (
    <Container className="local-area">
      <div className="local-area-title">
        <h2>Top-Rated Call Girls in Tier 1 Cities</h2>
      </div>
      <div className="local-area-listing">
        {cityData.map((item: { label: string; city: string }, index: number) =>
          queryData?.state?.toLowerCase() != item.city.toLowerCase() ? (
            <div key={index} className="area-box">
              <Link href={`/${queryData.category}/${item.city}`}>{item.label}</Link>
            </div>
          ) : null,
        )}
      </div>
    </Container>
  );
}

export default memo(TopCity);
